import { Component, HostListener, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrl: './widget.component.scss',
  imports: [MatButtonModule, MatDialogContent, MatDialogActions],
})
export class WidgetComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<WidgetComponent>);
  private sanitizer = inject(DomSanitizer);
  iframeUrl: any;
  mapData: any;
  widgetUrl = environment.widgetUrl;

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.data && event.data.type === 'EXB_ROUTE_UPDATE') {
      this.mapData = event.data.payload;
    }
  }

  ngOnInit(): void {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.widgetUrl);
  }

  onClose(): void {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    this.dialogRef.close(this.mapData);
  }
}
